<template>
  <div>
    <div style="margin-bottom: 20px">
      <el-button type="primary" size="small" @click="exportTable">导出</el-button>
      <el-button type="primary" size="small" @click="add">新增</el-button>
    </div>
    <bsp-table :data.sync="list" ref="accountTable"
               :ciic-data-filter.sync="listQuery"
               :ciic-columns="tableColumn"
               @ciic-data-refresh="_getListpage">

                <bsp-table-column title="操作" width="100px" fixed="left">
                    <template slot-scope="scope">
                      <div class="ciic-table-operate">
                          <el-link type="primary" @click="showDialog(scope.row)" style="margin-right:10px;">编辑</el-link>
                          <el-link class="marginLeft10" type="primary" @click="deleteRow(scope.row)">删除</el-link>
                      </div>
                    </template>
                </bsp-table-column>

    </bsp-table>
  </div>
</template>

<script>
    import bspTable from "@/components/bsp/bsp-table/bsp-table";
    import bspTableColumn from "@/components/bsp/bsp-table-column/bsp-table-column";
    import { getdynamicList,updateListpage,addListpage,deleteData  } from  "@/api/demo/demo"
    import {getdynamicTable  } from  "@/api/common/common"
    import { mapGetters } from 'vuex';
    export default {
        name: "table",
        components: {bspTableColumn, bspTable},
        created(){
           this._getdynamicTable();
           this._getdynamicList();

        },
        mounted() {

        },
        computed: {
          ...mapGetters([
            'dicts',
          ]),
        },
        data(){
            return{
                dialogFormVisible: false,
                showTable: false,
                list: [],
                idcardList: [],
                tableColumn:[],
                listQuery:{
                  limit: 20,
                  page: 1,
                  total: 0,
                },
                listForm: {},
                id:'',
                textMap: {
                    add: '新增',
                    update: '编辑'
                },
                dialogStatus: 'add',
              tablePar:{
                infoSetId:'EMP_INFO',
              }
            }
        },
        methods: {
            //获取列表数据
            _getdynamicList(){
              getdynamicList(this.listQuery).then(res => {
                this.showTable = true
                this.listQuery.total = res.data.total
                this.list = res.data.records
              })
            },
             //获取列表表头数据
            _getdynamicTable(){
                getdynamicTable(this.tablePar).then(res => {
                this.tableColumn = res.data.dynamicTable
              })
            },
            //删除数据
            deleteRow(row){
                this.id = row.id;
                deleteData(this.id).then(res=>{
                  this.$message.success("删除成功")
                  this._getListpage();
                })
            },
            //导出表格
            exportTable(){

            },
            add(){
                const query = {   //getDynamicForm参数
                        operateType:0
                    }
                this.$router.push({ path: '/form/dynamicForm', query});
            }
        }
    }
</script>

<style scoped>

</style>
